import React from "react";
import { Segment, Header, Icon } from "semantic-ui-react";
import "./TodaySchedule.scss";

export function TodaySchedule(props) {
  const { schedule, currentDay } = props;

  const scheduleKey = `Day ${currentDay}`;
  const todayClasses = schedule?.scheduleByDay?.[scheduleKey] || [];

  return (
    <Segment className="dashboard-segment">
      <Header as="h3" dividing>
        <Icon name="clock outline" />
        Horario de Hoy - {currentDay}
      </Header>
      {todayClasses.length > 0 ? (
        <div className="schedule-timeline">
          {todayClasses.map((cls) => (
            <div className="timeline-item" key={cls.scheduleId}>
              <div className="time-slot">
                <span className="time">
                  {cls.startTime?.slice(0, 5)} {cls.endTime?.slice(0, 5)}
                </span>
              </div>
              <div className="class-info">
                <div className="subject">{cls.subject}</div>
                <div className="details">
                  <Icon name="map marker alternate" size="small" />
                  {cls.classroom} • {cls.teacher}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <Icon name="calendar times outline" />
          <p>No tienes clases programadas para hoy.</p>
        </div>
      )}
    </Segment>
  );
}
